import { render, staticRenderFns } from "./BreadcrumbManualAddedItems.vue?vue&type=template&id=bdf4d9e4"
import script from "./BreadcrumbManualAddedItems.vue?vue&type=script&lang=js"
export * from "./BreadcrumbManualAddedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports